// extracted by mini-css-extract-plugin
module.exports = {"inquiryMain":"inquiry_inquiryMain__1FrHp","mainTitle":"inquiry_mainTitle__3w4r1","inquiry":"inquiry_inquiry__3qycS","inquiryInput":"inquiry_inquiryInput__2cMCf"};